export default __webpack_public_path__ + "acd3a8745349c416222bc68504488563.jpg";